import { Messages } from "../../lib/locale";

export const English: Messages = {
  name: "English",
  helpTitle: "How to play",
  help1: `Every day, there is a new Mystery Country. Your goal is to guess which country it is using the fewest number of guesses. Each incorrect guess
  will appear on the globe with a colour indicating how close it is to the
  Mystery Country. The <b>hotter</b> the colour, the closer you are to the answer.`,
  help2: `For example, if the Mystery Country is <b>Japan</b>, then the following
  countries would appear with these colours if guessed:`,
  help3: `A new Mystery Country will be available every day!`,
  France: "France",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "South Korea",
  Aux1: `<b>["Click", "Tap"]</b> the globe to play!`,
  Aux2: "Have a question?",
  Aux3: "Check out the FAQ",
  Footer1: "by The Abe Train",
  Footer2: "Enjoying the game?",
  Footer3: "Buy me a coffee",
  Loading: "Loading...",
  FAQTitle: "FAQ",
  q1: "1. How is the distance between the answer and my guess calculated?",
  a1: "Distance between countries is defined as the minimum distance between their land borders along the Earth's surface. Territories (areas that appear in gray when their parent country is guessed) and water borders are not included in distance calculations.",
  q2: "2. How can I play the game if I am colour blind or visually impaired?",
  a2: "A high-contrast Colour Blind mode can be activated in <button>Settings</button>.",
  q3: "3. How does the game decide what is a valid country?",
  a3: "Globle uses this <a>framework</a> to determine what constitutes a valid guess.",
  q4: "4. Are autonomous but not sovereign countries in the game?",
  a4: "Some territories will appear in a neutral colour when their sovereign country is guessed, e.g. Greenland for Denmark. The location of these territories does not impact the colour of the sovereign country. Most small territories do not appear in the game, e.g. Curaçao.",
  q5: "5. I found today's mystery country! When do I get to play again?",
  a5: "The mystery country changes and your guesses reset at midnight in your time zone.",
  q6: "6. Are alternative spellings for countries acceptable?",
  a6: "There are many countries with multiple acceptable names. Some alternate spellings and previous names are accepted, e.g. Burma for Myanmar. As well, acronyms are acceptable for some multi-word countries, e.g. UAE for United Arab Emirates.",
  q7: "7. A country is missing or a border is incorrect. What can I do about it?",
  a7: "Geography can be a sensitive topic, and some countries' borders are disputed. If you believe a correction should be made, please politely raise an issue on {GitHub} or DM me on {Twitter}.",
  q8: "8. Why are my friend and I getting different mystery countries?",
  a8: "Sometimes updates to the game don't reach everyone's browsers/devices at the same time. To fix this issue, you can get the latest code by doing a hard refresh (Ctrl + Shift + R on desktop, instructions vary for mobile devices).",
  GameTitle: "Game",
  Game1: "Enter country name here",
  Game2: "Enter",
  Game3: "Enter the name of any country to make your first guess.",
  Game4: `Drag, <span>["click", "tap"]</span>, and zoom-in on the globe to help you find your next guess.`,
  Game5: "Invalid guess",
  Game6: "Country already guessed",
  Game7: "The Mystery Country is {answer}!",
  Game8: "Closest border",
  StatsTitle: "Statistics",
  Stats1: "Last win",
  Stats2: "Today's guesses",
  Stats3: "Games won",
  Stats4: "Current streak",
  Stats5: "Max streak",
  Stats6: "Average guesses",
  Stats7: "Avg. Guesses",
  Stats8: "Reset",
  Stats9: "Share",
  Stats10: "Are you sure you want to reset your score?",
  Stats11: "Stats erased.",
  Stats12: "Copied to clipboard!",
  SettingsTitle: "Settings",
  Settings1: "Day Theme",
  Settings2: "Night Theme",
  Settings3: "Colour Blind Mode On",
  Settings4: "Colour Blind Mode Off",
  Settings5: "Countries",
  Settings6: "Cities",
  Settings7: "Language",
  Settings8: "Globle: Cities Edition coming soon!",
  Settings9: "Practice",
  Settings10: "Rainbow On",
  Settings11: "Rainbow Off",
  Answer: "Answer",
  Closest: "Closest",
  Guessed: "Guessed",
  PracticeMode: "You are in practice mode.",
  PracticeExit: "Exit practice mode",
  PracticeNew: "New practice game",
  SortByGuesses: "Sort by order of guesses",
  SortByDistance: "Sort by distance",
};
